(() => {
  // Brug prefix fra nuværende URL (virker også med evt. /da/ osv.)
  const prefix = (() => {
    const p = location.pathname;
    const i = p.indexOf('/products/');
    return i >= 0 ? p.slice(0, i) : '';
  })();

  const cache = new Map(); // handle -> product JSON

  const params = new URLSearchParams(location.search);
  const DEBUG = params.has('exvatdebug');
  const log = (...a) => { if (DEBUG) console.log('[ex-vat]', ...a); };

  const toInt = (v) => (typeof v === 'string' ? parseInt(v, 10) : (v ?? 0));
  const toBool = (v) => v === true || v === 'true' || v === '1';

  // ---- DK money formatting: 12.375,00 ----
  function formatNumberDK(cents) {
    const sign = cents < 0 ? '-' : '';
    const abs = Math.abs(toInt(cents));
    const intPart = Math.floor(abs / 100);
    const frac = String(abs % 100).padStart(2, '0');
    const intWithDots = String(intPart).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${sign}${intWithDots},${frac}`;
  }

  function formatMoney(cents, moneyFormat) {
    const amount = formatNumberDK(cents);

    // Bevar currency/placering fra moneyFormat (fx " kr")
    if (typeof moneyFormat === 'string' && moneyFormat.length) {
      const placeholder = moneyFormat.match(/\{\{\s*[^}]+\s*\}\}/);
      if (placeholder) return moneyFormat.replace(placeholder[0], amount);
      // Hvis moneyFormat ikke har  (sjældent), så bare append tallet
      return `${amount} ${moneyFormat}`.trim();
    }

    // fallback hvis moneyFormat mangler
    return `${amount} kr`;
  }

  function calcExVat(incCents, vatPercent, taxesIncluded) {
    if (!taxesIncluded) return incCents;
    const divisor = 100 + vatPercent;
    return Math.round((incCents * 100) / divisor);
  }

  function findVariantIdFromUrl() {
    const urlId = new URL(location.href).searchParams.get('variant');
    return urlId ? urlId : null; // behold som string
  }

  async function getProduct(handle) {
    if (!handle) return null;
    if (cache.has(handle)) return cache.get(handle);

    const url = `${prefix}/products/${handle}.js`;
    log('fetch', url);

    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) {
      log('fetch failed', res.status, url);
      return null;
    }

    const data = await res.json();
    cache.set(handle, data);
    return data;
  }

  async function updateContainer(container) {
    const handle = (container.dataset.productHandle || '').trim();
    const vatPercent = toInt(container.dataset.vatPercent || 25);
    const taxesIncluded = toBool(container.dataset.taxesIncluded);
    const moneyFormat = container.dataset.moneyFormat;

    const variantIdStr = findVariantIdFromUrl();
    if (!handle || !variantIdStr) return;

    const product = await getProduct(handle);
    if (!product?.variants?.length) return;

    const variant = product.variants.find(v => String(v.id) === String(variantIdStr));
    if (!variant) {
      log('variant not found in product json', { handle, variantIdStr });
      return;
    }

    const priceInc = toInt(variant.price);
    const compareInc = toInt(variant.compare_at_price);

    const priceEx = calcExVat(priceInc, vatPercent, taxesIncluded);
    const compareEx = calcExVat(compareInc, vatPercent, taxesIncluded);

    const priceEl = container.querySelector('[data-exvat-price]');
    const compareEl = container.querySelector('[data-exvat-compare]');

    if (priceEl) priceEl.textContent = `${formatMoney(priceEx, moneyFormat)} ekskl. moms`;

    if (compareEl) {
      if (compareInc && compareInc > priceInc) {
        compareEl.hidden = false;
        compareEl.innerHTML = `<s>${formatMoney(compareEx, moneyFormat)}</s> ekskl. moms (før rabat)`;
      } else {
        compareEl.hidden = true;
        compareEl.textContent = '';
      }
    }

    log('updated', { handle, variantIdStr, priceInc, priceEx });
  }

  // Debounce + loop-guard (så MutationObserver ikke spammer)
  let raf = null;
  let internalWrite = false;

  function updateAll() {
    document.querySelectorAll('[data-exvat]').forEach(el => updateContainer(el));
  }

  function scheduleUpdate() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      raf = null;
      internalWrite = true;
      try {
        updateAll();
      } finally {
        // slip guard efter et tick
        setTimeout(() => { internalWrite = false; }, 0);
      }
    });
  }

  // 1) URL watcher (din vigtigste, fordi dit tema ændrer ?variant=)
  let lastVariantParam = null;
  setInterval(() => {
    const current = findVariantIdFromUrl();
    if (current !== lastVariantParam) {
      lastVariantParam = current;
      log('variant param changed', current);
      scheduleUpdate();
    }
  }, 200);

  // 2) Fallback events
  document.addEventListener('change', scheduleUpdate, true);
  document.addEventListener('click', scheduleUpdate, true);

  // 3) FANG når temaet re-renderer DOM’en (det er dét du oplever efter load)
  const mo = new MutationObserver((mutations) => {
    if (internalWrite) return;

    // Hvis noget under [data-exvat] ændres eller nye nodes kommer ind, så ret tilbage
    for (const m of mutations) {
      if (m.type === 'childList' && (m.addedNodes?.length || m.removedNodes?.length)) {
        scheduleUpdate();
        break;
      }
      if (m.type === 'characterData') {
        // tekst ændret et sted i DOM’en
        scheduleUpdate();
        break;
      }
    }
  });

  // Start observer (body er nok)
  if (document.body) {
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    });
  }

  // Init + “late updates” (nogle temaer opdaterer prisen efter 0.5-3 sek)
  scheduleUpdate();
  setTimeout(scheduleUpdate, 500);
  setTimeout(scheduleUpdate, 1500);
  setTimeout(scheduleUpdate, 3000);

  // Manual test-hjælper
  window.__exvat = { force: scheduleUpdate };
})();
